<div class="white-overlay">
	<div class="loader"></div>
</div>